import { render, staticRenderFns } from "./clientProfileAddUser.vue?vue&type=template&id=35ed25d1&scoped=true"
import script from "./clientProfileAddUser.vue?vue&type=script&lang=js"
export * from "./clientProfileAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed25d1",
  null
  
)

export default component.exports